module.exports = __webpack_public_path__ + "static/media/212.bb764e7b.mp3";